import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from '@ng-bootstrap/ng-bootstrap';
import { AddCampaignCustomerComponent } from '../add-campaign-customer/add-campaign-customer.component';
import { EmailTemplateModelComponent } from '../email-template-model/email-template-model.component';
import { CampaignServiceService } from '../../../../business-services/campaign-service.service';
import {
  CampaignFor,
  CampaignStatus,
  CampaignStepType,
  CampaignType,
  CampaignVia,
  ExecutionFrequency,
  WaitForCondition,
} from '../../../../business-entities/campaign-list-model';
import {
  CampaignDetailsModel,
  CampaignActivityModel,
  CampaignRequertResponseModel,
} from '../../../../business-entities/campaign-detail-model';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DatePipe } from '@angular/common';
import { TargetedGroupService } from '../../../../business-services/targeted-group.service';
import { TargetedGroupModel } from '../../../../business-entities/targeted-group-model';
import {
  QueryBuilderClassNames,
  QueryBuilderConfig,
} from 'ngx-angular-query-builder';
import { BrandService } from '../../../../business-services/brand.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import {
  CampaignMemberAddImportModel,
} from '../../../../business-entities/campaign-member-model';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { LanguageCode } from 'projects/Autofacets-Core/src/app/utils/enums';
import { TranslateService } from '@ngx-translate/core';
import { CampaignTemplateService } from '../../../../business-services/campaign-template.service';
import { TargetGroupRequestModel } from '../../../../business-entities/campaign-modal';
import * as Enums from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';

@Component({
  selector: 'app-edit-campaign',
  templateUrl: './edit-campaign.component.html',
  styleUrls: ['./edit-campaign.component.css'],
  providers: [CustomPaggerService],
})
export class EditCampaignComponent implements OnInit {

  //#region Declaration
  isCheckedRadio: boolean = false;
  isExecuteInStep = true;
  showFiller = false;
  showAddFilterGroup = false;
  showAddFilterGroupExclude = false;
  showSaveAndExecute = false;
  brandList = [];
  totalRecipientCount = 0;
  excludedRecipientCount = 0;
  selectedTargetedGroup = 0;

  @Input() actionFlag: any;
  @Input() campaignId: any;

  @ViewChild('a') divAccordion: any;

  campaignFor = CampaignFor;
  campaignType = CampaignType;
  campaignVia = CampaignVia;
  stepType = CampaignStepType;
  languageCode = LanguageCode;
  waitCondition = WaitForCondition;
  executionFrequency = ExecutionFrequency;

  includeJSON = { condition: 'and', rules: [] };
  excludeJSON = { condition: 'and', rules: [] };
  public includeQueryCtrl: FormControl;
  public excludeQueryCtrl: FormControl;
  config: QueryBuilderConfig = {
    fields: {
      Year: { name: 'Model Year', type: 'number' },
      CITY: { name: 'City', type: 'string', operators: ['=', '!=', 'like'] },
      CompanyMakeCode: {
        name: 'Brand',
        type: 'category',
        options: this.brandList,
      },
      DIAL_CODE: { name: 'Dial Code', type: 'number' },
    },
  };

  StartDate: any;
  EndDate: any;
  CampaignDetails: CampaignDetailsModel;
  CampaignActivity: CampaignActivityModel[] = [];
  CampaignRequertResponseModel: CampaignRequertResponseModel;
  targetedGroups: TargetedGroupModel[];
  campaignMembers = [];
  scrollDistance = 1;
  throttle = 100;
  targetedGroupRequest = {
    IncludeQuery: '',
    ExcludeQuery: '',
    SortColumn: '',
    SortDirection: '',
    StartRecordNumber: 0,
    NumberOfRecord: 25,
  };
  validQuery: boolean = true;
  generalStepNo = 0;
  popupCloseResult = false;
  culture: string;
  modelHeader: any;
  typeOfCustomer: string = 'include';

  isValidForSave = false;
  isValidForActive = false;
  errorInSteps = true;
  validationModel = {
    cmpName: true,
    cmpReqIncludeQuery: true,
    cmpInvalidIncludeQuery: true,
    cmpInvalidExcludeQuery: true,
    cmpStep: true,
  };
  addedRecipientList: CampaignMemberAddImportModel[] = [];
  includedRecipientList = [];
  excludedRecipientList = [];
  incTotalCount: number = 0;
  excTotalCount: number = 0;
  requestModal: TargetGroupRequestModel = {
    sortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    numberOfRecord: 25,
    searchTerm: '',
  };
  campaignForm: FormGroup;
  campaignName: string;
  campaignForList = [
    { id: 1, name: 'lblSales' },
    { id: 2, name: 'lblAfterSales' },
  ];
  campaignViaList = [
    { key: 1, campaignViaCode: 'lblEmail' },
    { key: 2, campaignViaCode: 'lblSms' },
    { key: 3, campaignViaCode: 'lblBoth' },
  ];
  campaignTypeList = [
    { key: 1, campaignTypeCode: 'lblScheduled' },
    { key: 2, campaignTypeCode: 'lblRecurring' },
    { key: 3, campaignTypeCode: 'lblExecuteNow' },
  ];
  frequencyList = [
    { key: 1, value: 'lblDaily' },
    { key: 2, value: 'lblWeekly' },
    { key: 3, value: 'lblMonthly' },
    { key: 4, value: 'lblYearly' },
  ];
  classNames: QueryBuilderClassNames = {
    removeIcon: 'fa fa-minus',
    addIcon: 'fa fa-plus',
    arrowIcon: 'fa fa-chevron-right px-2',
    rightAlign: 'order-12 ml-auto',
    switchRow: 'd-flex px-2',
    switchGroup: 'd-flex align-items-center',
    row: 'row p-2 m-1',
    rule: 'border',
    ruleSet: 'border',
    invalidRuleSet: 'alert alert-danger',
    emptyWarning: 'text-danger mx-auto',
    operatorControl: 'form-control',
    operatorControlSize: 'col-auto pr-0',
    fieldControl: 'form-control',
    fieldControlSize: 'col-auto pr-0',
    entityControl: 'form-control',
    entityControlSize: 'col-auto pr-0',
    inputControl: 'form-control',
    inputControlSize: 'col-auto',
  };
  //#endregion

  //#region Constructor and Init
  constructor(
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private modalService: NgbModal,
    private brandService: BrandService,
    private targetedGroupService: TargetedGroupService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private campaignTemplateService: CampaignTemplateService,
    private campaignServiceService: CampaignServiceService,
    private excelService: ExcelService,
    private cdRef: ChangeDetectorRef,
    private datepipe: DatePipe
  ) {
    this.defineModel();
  }
  ngOnInit(): void {
    let today = new Date();
    const isDisabled = this.CampaignDetails.isActive;
    const todayDate = this.datepipe.transform(
      today.setDate(today.getDate()),
      'dd.MM.yyyy'
    );
    this.campaignForm = this.formBuilder.group({
      name: [
        { value: '', disabled: isDisabled },
        [Validators.required],
      ],
      description: [{ value: '', disabled: isDisabled }],
      startDate: [
        { value: todayDate, disabled: isDisabled },
        [Validators.required],
      ],
      selectedFor: 1,
      selectedVia: 1,
      selectedType: 1,
      endDate: todayDate,
      selectedFrequency: 1,
    });

    if (this.campaignId != 0) this.getCampaignById();
    this.getBrand();
    this.getTargetedGroups();

    this.StartDate = this.datepipe.transform(
      today.setDate(today.getDate()),
      'dd.MM.yyyy'
    );
    this.includeQueryCtrl = this.formBuilder.control(this.includeJSON);
    this.excludeQueryCtrl = this.formBuilder.control(this.excludeJSON);
    this.culture = this.cookieservice.get('userSelectedLanguage');
  }
  //#endregion

  //#region Page Methods
  selectCampaignType(cmpType) {
    let today = new Date();
    this.StartDate = this.datepipe.transform(
      today.setDate(today.getDate()),
      'dd.MM.yyyy'
    );
    if (cmpType == this.campaignType.ExecuteNow)
      this.StartDate = this.datepipe.transform(new Date(), 'dd.MM.yyyy');
  }
  OnClose() {
    this.activeModal.close({ success: true });
  }
  get cf() {
    return this.campaignForm.controls;
  }
  onNext() {
    this.showSaveAndExecute = true;
    this.actionFlag = 'view';
    this.getCampaignById();
  }
  onChnageType(event) {
    if (
      event === this.campaignTypeList[2].key ||
      this.CampaignDetails.isActive
    ) {
      this.campaignForm.get('startDate').disable();
    } else {
      this.campaignForm.get('startDate').enable();
    }
  }
  async onConfirm(validationPopup) {
    await this.activeValidation();
    if (this.isValidForActive && this.isValidForSave) {
      let modelBodymsg =
        'This Campaign Will Activate and Execute on Scheduled Date';
      if (this.CampaignDetails.campaignType == this.campaignType.ExecuteNow)
        modelBodymsg =
          'This Campaign Will be Execute as soon as you confirm this';
      let modelHeadermsg = 'Activation';

      const modalRef = this.modalService.open(NgbdModalContent);
      modalRef.componentInstance.modelHeader = modelHeadermsg;
      modalRef.componentInstance.modelBody = modelBodymsg;
      modalRef.result.then(
        (_result) => {
          // This is intentional
        },
        (reason) => {
          this.popupCloseResult = this.getDismissReason(reason);
          if (this.popupCloseResult) {
            this.CampaignDetails.isActive = true;
            this.saveandNext();
          }
        }
      );
    } else {
      this.backEdit();
      this.modalService.open(validationPopup, { centered: true, size: 'lg' });
    }
  }
  async basicValidation(direct) {
    let openTabs = [];
    this.isValidForSave = true;
    this.validationModel.cmpName = true;
    this.validationModel.cmpInvalidExcludeQuery = true;
    this.validationModel.cmpInvalidIncludeQuery = true;
    if (!this.cf.name.value) {
      this.validationModel.cmpName = false;
      this.isValidForSave = false;
      openTabs.push('first');
    }

    if (this.includeJSON.rules.length > 0) {
      this.basicRulesetToSQL(this.includeJSON);
      if (!this.validQuery) {
        this.validationModel.cmpReqIncludeQuery = true;
        this.validationModel.cmpInvalidIncludeQuery = false;
        this.isValidForSave = false;
        openTabs.push('second');
      }
    }

    if (this.excludeJSON.rules.length > 0) {
      this.basicRulesetToSQL(this.excludeJSON);
      if (!this.validQuery) {
        this.validationModel.cmpInvalidExcludeQuery = false;
        this.isValidForSave = false;
        openTabs.push('four');
      }
    }

    if (this.CampaignActivity.length > 0) {
      this.validationModel.cmpStep = true;
      this.errorInSteps = true;
      this.CampaignActivity.forEach((x) => {
        let element1 = document.getElementById(x.stepNo + 'templateError');
        let element2 = document.getElementById(x.stepNo + 'descriptionError');
        if (element1) {
          if (x.templateId == 0) {
            element1.innerHTML = 'lblTemplateisRequired';
            this.isValidForSave = false;
            this.errorInSteps = false;
            openTabs.push('third');
          } else element1.innerHTML = '';
        }


        if (element2) {
          if (x.description == '') {
            element2.innerHTML = 'lblDescriptionIsRequired';
            this.isValidForSave = false;
            this.errorInSteps = false;
            openTabs.push('third');
          } else element2.innerHTML = '';
        }
      });
    }

    if (direct && !this.isValidForSave) {
      this.divAccordion.activeIds = openTabs;
      this.cdRef.detectChanges();
    }
  }

  async activeValidation() {
    this.isValidForActive = true;
    this.validationModel.cmpReqIncludeQuery = true;
    this.validationModel.cmpStep = true;
    if (this.includeJSON.rules.length == 0 && this.totalRecipientCount == 0) {
      this.validationModel.cmpReqIncludeQuery = false;
      this.isValidForActive = false;
    }

    if (this.CampaignActivity.length == 0) {
      this.validationModel.cmpStep = false;
      this.isValidForActive = false;
    }

    await this.basicValidation(false);
  }
  openPenelForValidation() {
    let openTab = [];
    if (!this.validationModel.cmpReqIncludeQuery) openTab.push('second');
    if (!this.validationModel.cmpStep) openTab.push('third');
    this.divAccordion.activeIds = openTab;
    this.cdRef.detectChanges();
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  backEdit() {
    this.showSaveAndExecute = false;
    this.actionFlag = 'edit';
  }
  AddCustomerModel(flag) {
    const modalref = this.modalService.open(AddCampaignCustomerComponent, {
      size: 'lg',
      windowClass: 'pop-wid1000',
    });
    modalref.componentInstance.actionFlag = flag;
    modalref.result.then((response) => {
      if (response?.success) {
        this.addedRecipientList = this.addedRecipientList.concat(response.data);
      }
    });
  }
  onTargetedGroupChange(id) {
    this.targetedGroupRequest.StartRecordNumber = 0;
    this.includeQueryCtrl.enable();
    this.includeJSON = { condition: 'and', rules: [] };
    if (this.targetedGroups.find((x) => x.id == id)) {
      this.includeJSON = JSON.parse(
        this.targetedGroups.find((x) => x.id == id).jsonQuery
      );
      this.includeQueryCtrl.disable();
    }
    this.includeQueryCtrl = this.formBuilder.control(this.includeJSON);
  }
  resetTargetedGroup() {
    this.getTargetedGroups();
    this.includedRecipientList = [];
    this.excludedRecipientList = [];
  }
  onScrollDown(isIncluded: boolean = true) {
    if (isIncluded) {
      if (this.incTotalCount > this.includedRecipientList.length) {
        this.targetedGroupRequest.StartRecordNumber =
          this.includedRecipientList.length;
        this.viewCustomer(false, true);
      }
    }
    else {
      if (this.excTotalCount > this.excludedRecipientList.length) {
        this.targetedGroupRequest.StartRecordNumber =
          this.excludedRecipientList.length;
        this.viewCustomer(false, false);
      }
    }
  }
  onViewCustomerScrollDown() {
    if (this.typeOfCustomer == "include") {
      if (this.totalRecipientCount > this.includedRecipientList.length) {
        this.targetedGroupRequest.StartRecordNumber =
          this.campaignMembers.length;
        this.getCampaignCustomers(true);
      }
    }
    else {
      if (this.excludedRecipientCount > this.excludedRecipientList.length) {
        this.targetedGroupRequest.StartRecordNumber =
          this.campaignMembers.length;
        this.getCampaignCustomers(false);
      }
    }
  }
  addStep(type: CampaignStepType) {
    this.generalStepNo++;
    this.CampaignActivity.push({
      id: 0,
      campaignId: 0,
      stepNo: this.generalStepNo,
      stepType: type,
      description: '',
      templateId: 0,
      waitDays: 1,
      waitCondition: WaitForCondition.MailSent,
      executionDate: new Date(),
      statistics: JSON.stringify({
        Sent: '0',
        Opened: '0',
        Clicked: '0',
        Bounced: '0',
        Unsubscribed: '0',
      }),
    });
  }
  deleteStep(stepNo) {
    let element = document.getElementById('step' + stepNo);
    element.parentNode.removeChild(element);
    this.CampaignActivity = this.CampaignActivity.filter(
      (x) => x.stepNo != stepNo
    );
  }
  deleteAllSteps() {
    this.CampaignActivity.forEach((x) => {
      let element = document.getElementById('step' + x.stepNo);
      element.parentNode.removeChild(element);
    });
    this.CampaignActivity = [];
    this.generalStepNo = 0;
  }
  onExecutionTypeChange() {
    this.deleteAllSteps();
    if (!this.isExecuteInStep) {
      this.addStep(this.stepType.Email);
      this.addStep(this.stepType.SMS);
      this.CampaignActivity[0].waitDays = 0;
      this.CampaignActivity[1].waitDays = 0;
    }
  }
  EmailTemplateModel(stepNo, templateType) {
    const modalref = this.modalService.open(EmailTemplateModelComponent, {
      size: 'lg',
      windowClass: 'pop-wid800',
    });
    modalref.componentInstance.templateType = templateType;
    modalref.componentInstance.selectedTemplateId = this.CampaignActivity.find(
      (x) => x.stepNo == stepNo
    ).templateId;
    modalref.result.then((response) => {
      if (response?.success) {
        if (response.template) {
          let element = document.getElementById('templateBtn' + stepNo);
          element.innerText = ' ' + response.template.name;
          this.CampaignActivity.find((x) => x.stepNo == stepNo).templateId =
            response.template.id;
        }
      }
    });
  }
  defineModel() {
    this.CampaignDetails = {
      name: '',
      description: '',
      campaignFor: CampaignFor.Sales,
      campaignVia: CampaignVia.Email,
      campaignType: CampaignType.Scheduled,
      startDate: null,
      endDate: null,
      includeCustomerQuery: '',
      includeCustomerJSON: '',
      excludeCustomerQuery: '',
      excludeCustomerJSON: '',
      executionFrequency: ExecutionFrequency.Daily,
      isActive: false,
      status: CampaignStatus.Draft,
      createdBy: this.userService.currentUserValue.name,
      updatedBy: this.userService.currentUserValue.name,
    };
  }
  valueToSQL(value) {
    switch (typeof value) {
      case 'string':
        return "'" + value + "'";
      case 'boolean':
        return value ? '1' : '0';
      case 'number':
        if (isFinite(value)) return value;
    }
  }
  isDefined(value) {
    return value !== undefined;
  }
  
  basicRulesetToSQL(ruleset) {
    this.validQuery = true;
    if (ruleset.rules.length === 0) return '';

    const ruleToSQL = (rule) => {
      if (rule.rules) {
        return '(' + this.basicRulesetToSQL(rule) + ')';
      }

      let column = rule.field,
        operator,
        value;

      switch (rule.operator) {
        case 'is null':
        case 'is not null':
          operator = rule.operator;
          value = '';
          break;
        case 'in':
        case 'not in':
          operator = rule.operator;
          if (this.isDefined(rule.value[0]) && Array.isArray(rule.value) && rule.value.length) {
            value = '(' + rule.value.map(this.valueToSQL).filter(this.isDefined).join(', ') + ')';
          }
          break;
        case 'like':
          operator = rule.operator;
          if (this.isDefined(rule.value)) {
            value = this.valueToSQL('%' + rule.value + '%');
          }
          break;
        default:
          operator = rule.operator;
          value = this.valueToSQL(rule.value);
          break;
      }

      return this.isDefined(column) && this.isDefined(value) && this.isDefined(operator)
        ? '(' + (column + ' ' + operator + ' ' + value).trim() + ')'
        : (this.validQuery = false);
    };

    const ruleIsValid = (rule) => {
      return this.isDefined(rule.field) && this.isDefined(rule.operator);
    };

    return ruleset.rules
      .map(ruleToSQL)
      .filter(ruleIsValid)
      .join(' ' + ruleset.condition + ' ');
  }
  
  
  showCustomerOnView(content, reqFor, isOpen: boolean = true) {
    this.targetedGroupRequest.StartRecordNumber = 0;
    this.targetedGroupRequest.NumberOfRecord = 25;
    this.targetedGroupRequest.IncludeQuery = this.basicRulesetToSQL(
      this.includeJSON
    );
    this.targetedGroupRequest.ExcludeQuery = "";
    this.typeOfCustomer = reqFor;
    if (reqFor == 'include') {
      this.modelHeader = this.translate.instant('lblTotalRecipients');
    }
    else {
      this.targetedGroupRequest.ExcludeQuery = this.basicRulesetToSQL(
        this.excludeJSON
      );
      this.modelHeader = this.translate.instant('lblExcludedRecipients');
    }
    if (isOpen) {
      this.campaignMembers = [];
      this.modalService.open(content, { centered: true, size: 'xl' });
    }
    if (reqFor == 'include') {
      this.getCampaignCustomers(true);
    }
    else {
      this.getCampaignCustomers(false);
    }
  }
  public async exportAsXLSX(_excel: number) {
    // TODO: Get it from db without pagination
  }
 
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  //#endregion

  //#region API Methods
  getCampaignById() {
    this.campaignServiceService
      .getCampaignById(this.campaignId)
      .then(async (response) => {
        if (response && response.statusCode == 200) {
          this.CampaignDetails = response.data.campaignDetails;
          this.CampaignActivity = response.data.campaignActivities;
          this.generalStepNo = this.CampaignActivity.length;
          if (this.CampaignDetails.includeCustomerJSON != null)
            this.includeJSON = JSON.parse(
              this.CampaignDetails.includeCustomerJSON
            );
          if (this.CampaignDetails.excludeCustomerJSON != null)
            this.excludeJSON = JSON.parse(
              this.CampaignDetails.excludeCustomerJSON
            );

          this.StartDate = this.datepipe.transform(
            this.CampaignDetails.startDate,
            'dd.MM.yyyy'
          );
          this.EndDate = this.datepipe.transform(
            this.CampaignDetails.endDate,
            'dd.MM.yyyy'
          );
          this.includeQueryCtrl = this.formBuilder.control(this.includeJSON);
          this.excludeQueryCtrl = this.formBuilder.control(this.excludeJSON);

          this.campaignForm.patchValue({
            name: this.CampaignDetails.name,
            description: this.CampaignDetails.description,
            startDate: this.StartDate,
            selectedFor: this.CampaignDetails.campaignFor,
            selectedVia: this.CampaignDetails.campaignVia,
            selectedType: this.CampaignDetails.campaignType,
            endDate: this.EndDate,
            selectedFrequency: this.CampaignDetails.executionFrequency,
          });

          if (this.actionFlag == 'view') {
            this.getTemplateAndCustomerCount();
          }
        }
      });
  }
  async getTemplateAndCustomerCount() {
    this.getTemplateDetails();
    this.targetedGroupRequest.IncludeQuery = '';
    this.targetedGroupRequest.ExcludeQuery = '';
    this.targetedGroupRequest.StartRecordNumber = 0;
    this.targetedGroupRequest.NumberOfRecord = 1;

    if (this.includeJSON.rules.length > 0) {
      this.totalRecipientCount = 0;
      this.targetedGroupRequest.IncludeQuery = this.basicRulesetToSQL(
        this.includeJSON
      );
      this.showCustomerOnView('', 'include', false);
    }

    if (this.excludeJSON.rules.length > 0) {
      this.excludedRecipientCount = 0;
      this.targetedGroupRequest.ExcludeQuery = this.basicRulesetToSQL(
        this.excludeJSON
      );
      this.showCustomerOnView('', 'exclude', false);
    }
  }
  async saveandNext() {
    await this.basicValidation(true);
    if (this.isValidForSave) {
      this.CampaignDetails.name = this.cf.name.value;
      this.CampaignDetails.description = this.cf.description.value;
      this.CampaignDetails.campaignFor = this.cf.selectedFor.value;
      this.CampaignDetails.campaignVia = this.cf.selectedVia.value;
      this.CampaignDetails.campaignType = this.cf.selectedType.value;
      this.CampaignDetails.executionFrequency = this.cf.selectedFrequency.value;

      this.CampaignDetails.includeCustomerJSON = JSON.stringify(
        this.includeJSON
      );
      this.CampaignDetails.excludeCustomerJSON = JSON.stringify(
        this.excludeJSON
      );
      this.CampaignDetails.includeCustomerQuery = this.basicRulesetToSQL(
        this.includeJSON
      );
      this.CampaignDetails.excludeCustomerQuery = this.basicRulesetToSQL(
        this.excludeJSON
      );
      this.CampaignDetails.startDate = Utility.getDateStringToDate(
        this.StartDate
      );
      this.CampaignDetails.endDate = Utility.getDateStringToDate(this.EndDate);

      this.generalStepNo = 1;
      this.CampaignActivity.forEach((x) => (x.stepNo = this.generalStepNo++));

      this.CampaignRequertResponseModel = {
        campaignActivities: this.CampaignActivity,
        campaignDetails: this.CampaignDetails,
      };
      this.spinner.show();
      this.campaignServiceService
        .addUpdateCampaigns(this.CampaignRequertResponseModel)
        .then(async (response) => {
          if (response && response.statusCode == 201) {
            if (response.data > 0) {
              if (this.addedRecipientList.length > 0) {
                this.addedRecipientList.forEach((x) => {
                  x.CampaignId = response.data;
                  x.EmailConsent = true;
                  x.SMSConsent = true;
                  
                });
                await this.targetedGroupService
                  .InsertCampaignMembers(this.addedRecipientList)
                  .then((_response) => {
                    this.addedRecipientList = [];
                  });
              }
              let successmsg = this.translate.instant('lblCampaignSaveMessage');
              if (this.CampaignDetails.isActive) {
                this.activeModal.close({ success: true });
                if (
                  this.CampaignDetails.campaignType ==
                  this.campaignType.ExecuteNow
                )
                  successmsg = this.translate.instant(
                    'lblCampaignisExecutionMessage'
                  );
                else
                  successmsg = this.translate.instant(
                    'lblCampaignisActivatedMessage'
                  );
              }
              this.toastr.success(successmsg);
              this.campaignId = response.data;
              this.actionFlag = 'view';
              this.getCampaignById();
              this.showSaveAndExecute = true;
            }
          }
        }).finally(() => { this.spinner.hide(); });
    }
  }
  getBrand() {
    this.brandService.getBrand().then((response) => {
      if (response) {
        response.forEach((x) => {
          this.brandList.push({ name: x.brandName, value: x.brandCode });
        });
      }
    });
  }
  getTargetedGroups() {
    this.targetedGroupService
      .getTargetedGroups(this.requestModal)
      .then((response: any) => {
        if (response) {
          this.targetedGroups = response.data;
        }
      });
  }
  async viewCustomer(isReset: boolean = true, isIncluded: boolean = true) {
    let valid = false;
    this.targetedGroupRequest.IncludeQuery = this.basicRulesetToSQL(
      this.includeJSON
    );
    this.targetedGroupRequest.ExcludeQuery = "";
    valid = this.includeJSON.rules.length !== 0 && this.validQuery;
    if (!isIncluded) {
      this.targetedGroupRequest.ExcludeQuery = this.basicRulesetToSQL(
        this.excludeJSON
      );
      valid = this.excludeJSON.rules.length !== 0 && this.validQuery;
    }

    if (valid) {
      this.spinner.show();
      this.getCampaignMemberByQuery(isReset,isIncluded)
    } else {
      if (isIncluded) {
        this.includedRecipientList = [];
        this.incTotalCount = 0;
        this.excludedRecipientList = [];
        this.excTotalCount = 0;
      } else {
        this.excludedRecipientList = [];
        this.excTotalCount = 0;
      }
    }
  }

 async getCampaignMemberByQuery(isReset,isIncluded){
    await this.targetedGroupService
    .getCampaignMemberByQuery(this.targetedGroupRequest)
    .then((response: any) => {
      if (isReset) {
        if (isIncluded) {
          this.includedRecipientList = [];
          this.excludedRecipientList = [];
          this.targetedGroupRequest.StartRecordNumber = 0;
          this.incTotalCount = 0;
          this.excTotalCount = 0;
        } else {
          this.excludedRecipientList = [];
          this.targetedGroupRequest.StartRecordNumber = 0;
          this.excTotalCount = 0;
        }
      }
      if (response?.data.length > 0) {
        if (isIncluded) {
          this.includedRecipientList.push(...response.data);
          this.incTotalCount = response.data[0].totalCount;
        } else {
          this.excludedRecipientList.push(...response.data);
          this.excTotalCount = response.data[0].totalCount;
        }
      }
    })
    .finally(() => this.spinner.hide());
  }
  getTemplateDetails() {
    this.CampaignActivity.forEach((x) => {
      x.statisticsJson = JSON.parse(x.statistics);
      this.campaignTemplateService
        .getTemplateById(x.templateId)
        .then((response) => {
          if (response && response.statusCode == 200) {
            x.template = response.data.body;
          }
        });
    });
  }
  getCampaignCustomers(isIncluded: boolean = true) {
    this.spinner.show();
    this.targetedGroupService
      .getCampaignMemberByQuery(this.targetedGroupRequest)
      .then((response: any) => {
        if (response?.data.length > 0) {
          this.campaignMembers.push(...response.data);
          if (isIncluded) {
            this.totalRecipientCount = response.data[0].totalCount;
          } else {
            this.excludedRecipientCount = response.data[0].totalCount;
          }
        }
      }).finally(() => this.spinner.hide());
  }
  //#endregion
}
